"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

// Analytics próprio: 1 page view por rota + cliques em qualquer elemento com
// data-track="contato|social|play" (data-label diz qual). Downloads são contados
// no servidor (/d/[id]). sendBeacon não atrasa a navegação nem o clique.

function send(t: string, l?: string) {
  const body = JSON.stringify({ t, l, p: location.pathname, r: document.referrer });
  if (!navigator.sendBeacon?.("/api/track", new Blob([body], { type: "application/json" }))) {
    fetch("/api/track", { method: "POST", body, keepalive: true, headers: { "Content-Type": "application/json" } }).catch(() => {});
  }
}

export function Tracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    send("pageview");
  }, [pathname]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const el = (e.target as HTMLElement).closest<HTMLElement>("[data-track]");
      if (el) send(el.dataset.track!, el.dataset.label);
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  return null;
}
